import React from 'react';
import { MsalProvider } from "@azure/msal-react"
import { useMsalInstance } from '../hooks/use-msal-instance';
import { Provider } from 'react-redux';
import store from '../redux/store';

export const Providers = ({ children }: { children: React.ReactNode }) => {
   const instance = useMsalInstance();

  if(!instance || instance.getActiveAccount() === null) {
    return <></>
  }

  return (
    <Provider store={store}>
      <MsalProvider instance={instance}>
        {children}
      </MsalProvider>
    </Provider>
  )
}